<template>
    <div class="column-layout clearfix" style="height: 100%; overflow: hidden;">
        <div class="left-column fl">
            <div class="tab-container base">
                <div class="tabs-nav">
                    <ul class="head">
                        <li class="head-item current">机构信息</li>
                    </ul>
                </div>
            </div>
            <div class="table-layout" id="tree-menu" style="overflow-y: auto">
                <el-tree :props="props" :load="loadNode" lazy @node-click="handleNodeClick"></el-tree>
            </div>
        </div>
        <div class="right-column fl" style="height: 100%">
            <div class="tab-container base">
                <div class="tabs-nav">
                    <ul class="head clearfix">
                        <li class="head-item current">
                            <a class="font14">员工信息</a>
                        </li>
                    </ul>
                </div>
            </div>
            <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
            <div class="table-layout" style="overflow-y: auto;height: calc(100% - 150px)">
                <el-table ref="multipleTable" :data="outerStaffList" border tooltip-effect="dark" style="width: 100%" @select="handleSelectionChange">
                    <el-table-column align="center" type="selection" width="55"></el-table-column>
                    <el-table-column prop="orgFullPathName" label="所属机构" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="no" label="用户编号" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="name" label="用户名称" align="left" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="namePy" label="名称拼音" align="left" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="rankName" label="职衔" align="left" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="phoneNo" label="手机号" align="center" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" align="center" width="140" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import {Utils} from '../../app.base'
import {Vue, MsgBox} from '../../app.vues'

import oaAuditApi from '../../api/oaAudit'

import SwbQuerySortArea from '../query/QuerySortArea';

Vue.regist(SwbQuerySortArea);

let searchConfigData = {
    'queryFields': [{
        'type': 'Text',
        'label': '用户名称',
        'code': 'name',
        'valueType': 'String',
        'basic': true
    }, {
        'type': 'Text',
        'label': '名称拼音',
        'code': 'namePy',
        'valueType': 'String',
        'basic': true
    }, {
        'type': 'Text',
        'label': '手机号',
        'code': 'phoneNo',
        'valueType': 'String',
        'basic': true
    }],
    'sortFields': []
};
export default {
    name: 'swb-oa-audit-bp-staff-list',
    desc: '审批业务流程节点-设置审批人',
    props: {
        oldSelectStaffList: {
            type: Array,
            default: []
        },
    },
    data: function () {
        return {
            queryConfig: {},
            outerStaffList: [],
            curTreeData: {},    // 当前所在的树节点数据
            //
            props: {
                label: 'name',
                children: 'children',
                isLeaf: 'leaf'
            },
            selectStaffList: []
        }
    },
    created: function () {
        let oldSelectStaffList = this.oldSelectStaffList || [];
        if (!Utils.isNoB(oldSelectStaffList) && oldSelectStaffList.length > 0) {
            this.selectStaffList = Utils.merge([], oldSelectStaffList);
        }
        this.queryConfig = searchConfigData || {};
    },
    methods: {
        loadNode(node, resolve) {
            let self = this;
            let currentData = node.data || {};
            if (Utils.isNoB(currentData.children) || currentData.children.length <= 0) {
                this.getOuterOrgList(currentData.id, function (outerOrgList) {
                    currentData['children'] = Utils.merge([], outerOrgList);
                    //
                    resolve(outerOrgList);
                    //
                    self.curTreeData = outerOrgList[0]; // 此代码兼容物美，错误数据
                    if (!Utils.isNoB(outerOrgList) && outerOrgList.length > 0 && outerOrgList[0].level == 1) {
                        // self.handleNodeClick(outerOrgList[0]); // 生产数据量大，此处不查询
                    }
                });
            } else {
                resolve(currentData.children);
            }
            this.curTreeData = currentData;
        },
        getOuterOrgList: function (parentOrgJointId, callbackFunc) {
            let params = {
                parentOrgJointId: parentOrgJointId || -1
            };
            let theLoad = MsgBox.loading();
            oaAuditApi.getOuterOrgList(params, function (result) {
                theLoad.hide();
                if (result.type === 'info') {
                    let outerOrgList = result.data || [];
                    //
                    callbackFunc(outerOrgList);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getOuterOrgStaffList: function (data, callbackFunc) {
            let params = {
                orgCode: data.code,
                orgJointId: data.id,
            };
            let theLoad = MsgBox.loading();
            oaAuditApi.getOuterOrgStaffList(params, function (result) {
                theLoad.hide();
                if (result.type === 'info') {
                    let outerStaffList = result.data || [];
                    // 去除禁用人员
                    let staffList = [];
                    outerStaffList.forEach(function (itemInfo) {
                        if (!Utils.isTrue(itemInfo.disabled) && !Utils.isTrue(itemInfo.quitFlag)) {
                            staffList.push(itemInfo)
                        }
                    });
                    //
                    if (staffList.length > 0) {
                        data.staffList = Utils.merge([], staffList);
                    }
                    callbackFunc(staffList);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 树点击事件
        handleNodeClick: function (data) {
            let self = this;
            if ((Utils.isNoB(data.staffList) || data.staffList.length <= 0) && data.level > 1) {
                this.getOuterOrgStaffList(data, function (outerStaffList) {
                    self.outerStaffList = Utils.merge([], outerStaffList);
                    //
                    self.setSelectStaff();
                });
            } else {
                this.outerStaffList = Utils.merge([], data.staffList);
                //
                self.setSelectStaff();
            }
            this.curTreeData = data;
        },
        //
        handleSelectionChange(selection, row) {
            let selectStaffList = this.selectStaffList || [];
            let selectIds = selectStaffList.pluck('id');
            let index = selectIds.indexOf(row.id);
            if (index >= 0) {
                selectStaffList.splice(index, 1);
            } else {
                selectStaffList.push(row);
            }
            this.selectStaffList = Utils.merge([], selectStaffList);
        },
        // 人员选择回显
        setSelectStaff: function () {
            setTimeout(() => {
                let selectStaffList = this.selectStaffList || [];
                for (var i = 0; i < selectStaffList.length; i++) {
                    let selectItem = selectStaffList[i];
                    let outerStaffList = this.outerStaffList || [];
                    let outerStaff = outerStaffList.find(function (outerStaff) {
                        return outerStaff.id == selectItem.id || outerStaff.no == selectItem.no;    // 编号用于-重复申请回显
                    });
                    if (!Utils.isNoB(outerStaff)) {
                        selectStaffList[i] = Utils.merge({}, outerStaff);
                    }
                    //
                    this.$refs.multipleTable.toggleRowSelection(outerStaff, true);
                }
            }, 300);
        },
        // 人员模糊查询
        queryHandler(queryModel) {
            let filterItems = queryModel.filterItems || {};
            if (Utils.isNoB(filterItems.name) && Utils.isNoB(filterItems.namePy) && Utils.isNoB(filterItems.phoneNo)) {
                this.handleNodeClick(this.curTreeData);
            } else {
                this.getOuterOrgLikeStaffList(filterItems);
            }
        },
        // 人员模糊查询接口
        getOuterOrgLikeStaffList: function (filterItems) {
            let self = this;
            let params = filterItems;
            let theLoad = MsgBox.loading();
            oaAuditApi.getOuterOrgLikeStaffList(params, function (result) {
                theLoad.hide();
                if (result.type === 'info') {
                    let outerStaffList = result.data || [];
                    // 去除禁用人员
                    let staffList = [];
                    outerStaffList.forEach(function (itemInfo) {
                        if (!Utils.isTrue(itemInfo.disabled) && !Utils.isTrue(itemInfo.quitFlag)) {
                            staffList.push(itemInfo)
                        }
                    });
                    self.outerStaffList = Utils.merge([], staffList);
                    //
                    self.setSelectStaff();
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },

        getDlgResult: function () {
            let result = {
                type: 'info',
            };
            let selectStaffList = this.selectStaffList || [];
            if (selectStaffList.length <= 0) {
                result.type = 'warn';
                result.message = '请选择审批人员';
                return result;
            }
            result.data = selectStaffList;
            return result;
        }
    }
}
</script>

<style>
.el-table__header-wrapper .has-gutter .cell .el-checkbox {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/compo/oaAudit/MerchtAuditBpStaffList.vue